/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { MyWanIpServiceRepositoryImpl } from '../impls/MyWanIpServiceRepositoryImpl';
import { IMyWanIpServiceRepository } from '../interfaces/IMyWanIpServiceRepository';
import { TIpAddress, TServicesParams } from '../types';

export class MyWanIpService implements IMyWanIpServiceRepository {
    private oMyWanIpServiceRepository: MyWanIpServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oMyWanIpServiceRepository = new MyWanIpServiceRepositoryImpl(params);
    }

    async getMyWanIpAddress(): Promise<TIpAddress> {
        return this.oMyWanIpServiceRepository.getMyWanIpAddress();
    }
}
